function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "1SXCtb4sW6M13flTzXHDta",
  x1: 10.645,
  x2: 38.25,
  y1: 11.8,
  y2: 36.027,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#3bc9f3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.243,
  stopColor: "#37c3f0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.584,
  stopColor: "#2ab0e7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.979,
  stopColor: "#1693d9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1591d8"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#1SXCtb4sW6M13flTzXHDta)",
  d: "M28,4C12,4,4,18.559,4,28c0,8.182,3,10,5.23,10c4.3,0,6.335-7,9.77-7c1.533,0,3,1.076,3,3c0,2.671-3,2.753-3,6.389C19,41.72,20.37,44,23.332,44C31.792,44,44,34,44,20.5C44,8.145,35,4,28,4z M25.5,29c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5s2.5,1.119,2.5,2.5S26.881,29,25.5,29z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M38.429,35.535L39,25v-2.741l2.308-4.161c0.361-0.653,0.352-1.428-0.027-2.071C40.901,15.384,40.229,15,39.482,15h-7.965c-0.746,0-1.419,0.384-1.798,1.027c-0.379,0.643-0.389,1.417-0.027,2.071L32,22.259l0.002,2.795l0.845,15.588C34.851,39.289,36.767,37.564,38.429,35.535z",
  opacity: 0.05
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.619,16.014c-0.604,0.322-0.87,1.153-0.489,1.842l2.37,4.273l0.001,2.898l0.828,15.272c1.624-1.141,3.18-2.539,4.567-4.153L38.5,25v-2.871l2.37-4.274c0.381-0.689,0.115-1.521-0.489-1.842c-0.189-0.322-1.229-0.514-1.602-0.514h-6.554C31.852,15.5,30.808,15.692,30.619,16.014z",
  opacity: 0.07
});

var _ref6 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "1SXCtb4sW6M13flTzXHDtb",
  cx: 15.5,
  cy: 17.5,
  r: 4.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
}));

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 17.5,
  r: 4.5,
  fill: "url(#1SXCtb4sW6M13flTzXHDtb)",
  opacity: 0.15
});

var _ref8 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "1SXCtb4sW6M13flTzXHDtc",
  cx: 10.5,
  cy: 26.5,
  r: 4.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
}));

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 26.5,
  r: 4.5,
  fill: "url(#1SXCtb4sW6M13flTzXHDtc)",
  opacity: 0.15
});

var _ref10 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "1SXCtb4sW6M13flTzXHDtd",
  cx: 13.51,
  cy: 13.722,
  r: 6.873,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#e85182"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#d03767"
}));

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  cx: 15.5,
  cy: 16.5,
  r: 3.5,
  fill: "url(#1SXCtb4sW6M13flTzXHDtd)"
});

var _ref12 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "1SXCtb4sW6M13flTzXHDte",
  cx: 24.5,
  cy: 12.5,
  r: 4.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopOpacity: 0
}));

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 12.5,
  r: 4.5,
  fill: "url(#1SXCtb4sW6M13flTzXHDte)",
  opacity: 0.15
});

var _ref14 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "1SXCtb4sW6M13flTzXHDtf",
  cx: 22.715,
  cy: 8.859,
  r: 6.758,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#835fc1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#634796"
}));

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  cx: 24.5,
  cy: 11.5,
  r: 3.5,
  fill: "url(#1SXCtb4sW6M13flTzXHDtf)"
});

var _ref16 = /*#__PURE__*/React.createElement("radialGradient", {
  id: "1SXCtb4sW6M13flTzXHDtg",
  cx: 8.46,
  cy: 22.546,
  r: 6.755,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fee100"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f7a511"
}));

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  cx: 10.5,
  cy: 25.5,
  r: 3.5,
  fill: "url(#1SXCtb4sW6M13flTzXHDtg)"
});

var _ref18 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "1SXCtb4sW6M13flTzXHDth",
  x1: 33,
  x2: 38,
  y1: 23.5,
  y2: 23.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#b0b0b0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#a1a1a1"
}));

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  width: 5,
  height: 3,
  x: 33,
  y: 22,
  fill: "url(#1SXCtb4sW6M13flTzXHDth)"
});

var _ref20 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "1SXCtb4sW6M13flTzXHDti",
  x1: 35.5,
  x2: 35.5,
  y1: 45.645,
  y2: 25.176,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#4a4a4a"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.659,
  stopColor: "#323232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#232323"
}));

var _ref21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#1SXCtb4sW6M13flTzXHDti)",
  d: "M35.5,46L35.5,46c-0.763,0-1.393-0.597-1.435-1.359L33,25h5l-1.065,19.641C36.893,45.403,36.263,46,35.5,46z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fill: "#f6f6f6",
  d: "M38,22h-5l-2.433-4.386C30.166,16.889,30.69,16,31.518,16h7.965c0.828,0,1.352,0.889,0.95,1.614L38,22z"
});

function SvgPaint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaint);
export default __webpack_public_path__ + "static/media/paint.1cee0d3f.svg";
export { ForwardRef as ReactComponent };